export const FINANCE_READ_PERM = 'finance:ledger:read'
export const FINANCE_WRITE_PERM = 'finance:ledger:write'
export const FINANCE_ACCOUNT_READ = 'finance:account:read'
export const FINANCE_ACCOUNT_WRITE = 'finance:account:write'
export const FINANCE_PARTY_READ = 'finance:party:read'
export const FINANCE_PARTY_WRITE = 'finance:party:write'
export const FINANCE_CATEGORY_PERM = 'finance:category:manage'
export const FINANCE_EDOC_READ = 'finance:edoc:read'
export const FINANCE_EDOC_WRITE = 'finance:edoc:write'
export const FINANCE_TAX_READ = 'finance:tax:read'
export const FINANCE_PAYMENT_WRITE = 'finance:payment:write'
export const FINANCE_IBAN_PERM = 'finance:iban:reveal'
export const FINANCE_GL_READ = 'finance:gl:read'
export const FINANCE_OBLIGATION_READ = 'finance:obligation:read'
export const FINANCE_OBLIGATION_MANAGE = 'finance:obligation:manage'
export const FINANCE_VOID_APPROVE = 'finance:void:approve'
export const FINANCE_VOID_OWNER_APPROVE = 'finance:void:owner_approve'
export const FINANCE_PERSONAL_USE = 'finance:personal:use'
export const FINANCE_LOAN_READ = 'finance:loan:read'
export const FINANCE_LOAN_CREATE = 'finance:loan:create'
export const FINANCE_LOAN_PAY = 'finance:loan:pay'
export const FINANCE_LOAN_UNPAY = 'finance:loan:unpay'
export const FINANCE_LOAN_EDIT = 'finance:loan:edit'
export const FINANCE_LOAN_DELETE = 'finance:loan:delete'
export const FINANCE_CASH_ADVANCE_READ = 'finance:cash_advance:read'
export const FINANCE_CASH_ADVANCE_CREATE = 'finance:cash_advance:create'
export const FINANCE_CASH_ADVANCE_PAY = 'finance:cash_advance:pay'
export const FINANCE_CASH_ADVANCE_UNPAY = 'finance:cash_advance:unpay'
export const FINANCE_CASH_ADVANCE_EDIT = 'finance:cash_advance:edit'
export const FINANCE_CASH_ADVANCE_DELETE = 'finance:cash_advance:delete'
export const FINANCE_BANK_STATEMENT_READ = 'finance:bank_statement:read'
export const FINANCE_BANK_STATEMENT_DOWNLOAD = 'finance:bank_statement:download'
export const FINANCE_BANK_STATEMENT_UPLOAD = 'finance:bank_statement:upload'
export const FINANCE_BANK_STATEMENT_DELETE = 'finance:bank_statement:delete'
export const FINANCE_PAYMENT_DIRECT = 'finance:payment:direct'
export const FINANCE_PAYMENT_REQUEST_CREATE = 'finance:payment_request:create'
export const FINANCE_PAYMENT_REQUEST_READ = 'finance:payment_request:read'
export const FINANCE_PAYMENT_REQUEST_APPROVE = 'finance:payment_request:approve'
export const FINANCE_PAYMENT_REQUEST_SETTINGS = 'finance:payment_request:settings'
